// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"GridLayout_cardContainer__1Tc9E","promptCol":"GridLayout_promptCol__2Oy6X","answerCol":"GridLayout_answerCol__2dRgn","answerCard":"GridLayout_answerCard__14OzY"};